module.exports = __webpack_public_path__ + "img/p3.c402834b.png";